// extracted by mini-css-extract-plugin
export default {"wrapper":"feature-card_wrapper__slUXy","boxTitle":"feature-card_boxTitle__xNKyY","boxImg":"feature-card_boxImg__cXh-M"};